import React  from 'react';
import styled from 'styled-components';
const Styles = styled.div`
  width: 100%;
  height: 30vh;
  height: 30lvh;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  margin-bottom: -5vh;
  margin-bottom: -5lvh;
`
export default function ImageTop9 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  return (
    <Styles>
      <img src={data.Image} alt='background'/>
    </Styles>
  )
}

